import { Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import Button from '../Button';

function MobileOffersButton({ ctaText, onClick }) {
  const theme = useTheme();

  return (
    <Box
      display={{ xs: 'flex', sm: 'none' }}
      position="fixed"
      bottom={0}
      width="100%"
      backgroundColor="common.white"
      justifyContent="center"
      px={2}
      pb={2}
      py={3}
      boxShadow={theme.shadows[4]}
    >
      <Button
        onClick={onClick}
        sx={{
          borderRadius: 0,
          width: '100%',
          backgroundColor: 'orange.500',
          py: 1.25,
          color: 'common.black',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          '&:hover, &:focus': {
            backgroundColor: 'orange.700',
          },
        }}
      >
        {ctaText}
      </Button>
    </Box>
  );
}

MobileOffersButton.propTypes = {
  ctaText: PropTypes.string,
  onClick: PropTypes.func,
};

export default MobileOffersButton;
